export default __webpack_public_path__ + "static/governance@2x-62180d7231035dfabfff33d9ee9555b7.png";